<template>
    <TreeSelect
        class="md:w-full"
        v-model="selectData"
        :options="dataList"
        v-on:update:model-value="modelValue"
    />
</template>


<script setup>
import {  computed,ref, watch } from "vue";
import TreeSelect from 'primevue/treeselect';

let parentKey;
let key;
let nameKey;
let selectData = defineModel()

const props = defineProps(['dataList','selectData','checkAll']);
const emits = defineEmits(['return'])



// 개발자가 직접 작성한 콜백 함수
function findParentKey(key) {
  if(key.includes('upd')){
    return false
  }
    return key.includes('up') // 배열 요소가 "green"과 같은지 확인합니다.
};

//1차원 배열 다차원 배열변환
const dataList = computed(()=>{
    
  try{
    if(props.dataList.length === 0) return
    [ parentKey ] = Array.from(new Set(props.dataList.map(item => Object.keys(item).find(key => findParentKey(key)))))
    if(!parentKey) return
    key = parentKey.split('up_').join('')
    nameKey = key.replaceAll('id','') + 'nm'
    const rootList = []
    props.dataList.filter(item => item[parentKey] === '').forEach((parentItem)=>{
      let row = {
        key: parentItem.class_id,
        label : parentItem[nameKey],
        data: parentItem,
      };
      rootList.push(row);
    })
    rearrange(rootList)
    if(props.checkAll){
      rootList.unshift({
        key: "all", // "전체" 노드의 고유 키
        label: "-", // 표시될 라벨
        data: null, // 선택 시 특별한 데이터 필요 없음
      });
    }
    return rootList
  }catch(e){
    console.log(e)
    return []
  }
 
})

//child depth 계속 생성
const rearrange = (rootList) => {
  try{
    rootList.forEach((item)=>{
      let childTree = [];
      props.dataList.forEach((i) => {
        if (i[parentKey] == item.key) {
          let row = {
            key: i[key],
            label : i[nameKey],
            data: i,
          };
          childTree.push(row);
        }
      });

      if (childTree?.length > 0) {
        item.children = childTree;
        rearrange(childTree);
      }
    })
  }catch(e){
    console.log(e)
    return rootList
  }

    
};

//부모페이지에 select된 값 전달
const modelValue = (data)=>{
    let [keyVal] = Object.keys(data)
    let returnData;
    props.dataList.forEach((item)=> {
        if(item[key] === keyVal){
            returnData = item
        }
    })

    emits('return',returnData)
}
</script>

<style scoped>
.p-treeselect{
    height: 28.22222px;
}

</style>